<template>
    <div>
        <div class="hero">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="hero-content">
                            <h1 class="display-4 font-weight-bold text-white">Alert Info</h1>
                            <h4 class="font-weight-light  text-white">SAVE ALERT</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="boxes-hero">
            <div class="container">
                <div class="row equal">
                    <div class="col-md-12">
                        <div class="box shadow-lg bg-white rounded">
                            <div style="padding: 30px">
                                <form @submit.prevent="saveAlert">
                                    <b-form-group label="Name Your Alert (ex: house, irrigation)" label-align-sm="left">
                                        <b-form-input
                                                id="save-alert-name"
                                                type="text"
                                                v-model="model.alertName"
                                                :disabled="form_method === update_method_name && !iseditable"
                                        />
                                    </b-form-group>

                                    <b-form-group label="Alert Type" label-align-sm="left">
                                        <b-form-select
                                                v-model="model.alertType"
                                                :disabled="form_method === update_method_name"
                                                :options="typeOptions"
                                                id="save-alert-type"
                                                @change="updateSettings"
                                        />
                                    </b-form-group>

                                    <b-form-group
                                            label-align-sm="left"
                                            :label="`Limit ${units_of_measure}`"
                                            :hidden="form_method === update_method_name && !iseditable"
                                    >
                                        <b-form-input
                                                id="save-alert-threshold"
                                                type="text"
                                                v-model="model.threshold"
                                        />
                                    </b-form-group>

                                  <b-form-group v-if="supportsTimeWindow"
                                      label-align-sm="left"
                                      label="Active Time Window">
                                    <br/>
                                    <b-form-checkbox-group
                                        v-model="timeWindowDays"
                                        :options="timeWindowDayOptions"/>
                                    <br/>
                                    <table>
                                      <tr>
                                        <td>Start Hour: </td>
                                        <td><b-form-select v-model="timeWindowStartHour" :options="timeWindowHourOptions"/></td>
                                        <td><b-form-select v-model="timeWindowStartHourAMorPM" :options="timeWindowAMPMOptions"/></td>
                                      </tr>
                                      <tr><td colspan="2">&nbsp;</td></tr>
                                      <tr>
                                        <td>End Hour: </td>
                                        <td><b-form-select v-model="timeWindowEndHour" :options="timeWindowHourOptions"/></td>
                                        <td><b-form-select v-model="timeWindowEndHourAMorPM" :options="timeWindowAMPMOptions"/></td>
                                      </tr>
                                    </table>
                                    <br/>
                                  </b-form-group>

                                    <b-form-group label="Alert Email Addresses (separate by commas)" label-align-sm="left">
                                        <b-form-input type="text" v-model="model.email" id="save-alert-email"/>
                                    </b-form-group>

                                    <b-form-group label="Alert Text (SMS) (separate by commas - xxx-xxx-xxxx)" label-align-sm="left">
                                        <b-form-input type="text" v-model="model.sms" id="save-alert-sms"/>
                                    </b-form-group>

                                    <div class="my-5 mx-4" v-if="items" :hidden="form_method === update_method_name && !iseditable">
                                        <p style="float:left">
                                            Selected {{ table_name }}:
                                            <b-link
                                                    style="margin-left:1rem"
                                                    @click="selectAllRows"
                                                    v-if="selected.length*2 <= items.length && selected.length !== items.length"
                                            > Select All </b-link>
                                            <b-link @click="clearSelected" style="margin-left:1rem" v-else> Clear All </b-link>
                                        </p>

                                        <b-table
                                                ref="selectableTable"
                                                selectable
                                                select-mode="multi"
                                                selected-variant="active"
                                                :items="items"
                                                :fields="fields"
                                                @row-selected="onRowSelected"
                                                responsive="sm"
                                        >
                                            <template v-slot:cell(selected)="{ rowSelected }">
                                                <template v-if="rowSelected">
                                                    <span aria-hidden="true">&check;</span>
                                                    <span class="sr-only">Selected</span>
                                                </template>
                                                <template v-else>
                                                    <span aria-hidden="true">&nbsp;</span>
                                                    <span class="sr-only">Not selected</span>
                                                </template>
                                            </template>
                                        </b-table>
                                    </div>

                                    <div class="mt-5 text-right">
                                        <b-btn
                                                type="light"
                                                variant="dark"
                                                id="save-alert-submit"
                                                style="font-size:1.08rem"
                                        >
                                            <strong>Save</strong>
                                        </b-btn>
                                        &nbsp;
                                        <b-btn
                                                id="cancel-alert-submit"
                                                :to="{ name: 'AlertList'}"
                                        >
                                            <strong>Cancel</strong>
                                        </b-btn>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { createAlert, getAlertTimezones, getAlertTypes, getAlert, updateAlert } from '../../networking/alerts'
    import { get_sensor_data, get_sensor_summary, get_devices_and_sensors } from '../../networking/devices'
    import { alert_form_config, map_units } from '../../helpers/alerts'
    import Vue from 'vue'

    const device_fields = [
        { key:'selected', label:'' },
        { key:'name' },
        { key:'device_type_name' },
        { key:'imei', label:'Serial Number' }
    ]

    const sensor_fields = [
        { key:'selected', label:'' },
        { key: 'device', label:'Sensor Device' },
        { key: 'sensor_type_name', label: 'Sensor Type', class:"d-none d-md-table-cell" },
        { key: 'podid', label: 'Sensor ID' }
    ]

    const create_method_name = 'CREATE'
    const update_method_name = 'UPDATE'

    export default {

        name: 'alert_create',
        props: {
            userData: { type: Object, required: true },
            id: { type: String, required: false },
        },

        data () {
            return {
                form_method: null,
                create_method_name: create_method_name,
                update_method_name: update_method_name,

                model: {'emailAdmin':0},
                typeOptions: [],
                criticalityTypeOptions: alert_form_config.criticalityTypeOptions,
                enableTypeOptions: alert_form_config.enableTypeOptions,
                timeZoneOptions: null,

                supportsTimeWindow: false,
                timeWindowDays: [0,1,2,3,4,5,6],
                timeWindowDayOptions: [
                  { text: 'Monday', value: 0},
                  { text: 'Tuesday', value: 1},
                  { text: 'Wednesday', value: 2},
                  { text: 'Thursday', value: 3},
                  { text: 'Friday', value: 4},
                  { text: 'Saturday', value: 5},
                  { text: 'Sunday', value: 6},
                ],
                timeWindowStartHour: 12,
                timeWindowEndHour: 12,
                timeWindowStartHourAMorPM: 'AM',
                timeWindowEndHourAMorPM: 'AM',
                timeWindowHourOptions: [1,2,3,4,5,6,7,8,9,10,11,12],
                timeWindowAMPMOptions: ['AM','PM'],

                device_fields: device_fields,
                sensor_fields: sensor_fields,

                devices: [],
                sensors: [],

                selected: [],
                items: null,
                fields: null,
                table_name: null,
                units_of_measure: '',
                isdevicealert: null,
                iseditable: true
			}
        },

        async created(){
            this.$route.fullPath.includes('create')
                ? this.setup_for_alert_creation()
                : this.setup_for_alert_update()
        },

        methods: {
            setup_for_alert_creation() {
                this.form_method = this.create_method_name

                this.model = {
                    ...this.model,
                    accountId: this.userData.accountId,
                    criticality: 'WARN',
                    enabled: '1'
                }
                this.retrieve_device_and_sensors()
                this.get_alert_types()
                this.get_timezone_options()
                this.populate_time_window_form()
            },

            async setup_for_alert_update() {
                this.form_method = update_method_name
                await this.retrieve_device_and_sensors()
                const generator = getAlert(this.id)
                const { value: { alert, data = [] }} = await generator.next()
                await this.get_alert_types()
                this.model = data
                this.iseditable = (
                        this.typeOptions.find(({value}) => this.model.alertType === value) || {iseditable: false}
                    ).iseditable

                this.updateSettings()
                this.get_timezone_options()
                this.populate_time_window_form()
            },

            saveAlert(){
                this.model.timeWindow = this.format_time_window()

                this.form_method === this.create_method_name
                    ? this.createAlert()
                    : this.updateAlert()
            },

            async createAlert () {
                const generator = createAlert({ 
                    ...this.model,
                    devices: this.format_device_array(),
                    sensors: this.format_sensor_array()
                 })

                const { value: { alert, data = [] }} = await generator.next()
                this.$emit('showAlert', alert.message, alert.variant, alert.variant === 'success' ? 1800 : 5000)
                alert.variant === 'success' ? this.$router.go(-1) : null
            },

            async updateAlert(){
                const generator = updateAlert({
                    ...this.model,
                    devices: this.format_device_array(),
                    sensors: this.format_sensor_array()
                })

                const { value: { alert, data = [] }} = await generator.next()
                this.$emit('showAlert', alert.message, alert.variant, alert.variant === 'success' ? 1800 : 5000)
                alert.variant === 'success' ? this.$router.go(-1) : null
            },

            async get_alert_types(){
                const { value: { data = [] }} = await getAlertTypes()
                this.typeOptions = data.filter(({ ishidden, isenabled }) => 
                    isenabled && !ishidden
                ).filter(({ iseditable }) => this.form_method !== update_method_name ? iseditable : true)
            },

            async get_timezone_options(){
                const { value: { data = [] }} = await getAlertTimezones()
                this.timeZoneOptions = data
            },

            onRowSelected(items){ this.selected = items },
            selectAllRows(){ this.$refs.selectableTable.selectAllRows() },
            clearSelected() { this.$refs.selectableTable.clearSelected() },

            updateSettings(){
                this.selected = []
                const { 
                    isdevicealert, sensortypes, unitsofmeasure 
                } = this.typeOptions.find(({ value }) => this.model.alertType === value)

                this.isdevicealert = isdevicealert === "True"
                this.units_of_measure = `${map_units(unitsofmeasure)}`
                this.applicable_sensor_types = sensortypes
                this.isdevicealert ? this.draw_devices() : this.draw_sensors()

                if (this.model.alertType == 'WATER_NUMBER')
                   this.supportsTimeWindow=false
                else
                  this.supportsTimeWindow=true

                Vue.nextTick(() => this.form_method === this.create_method_name
                    ? this.selectAllRows()
                    : this.filter_selected_by_alert_model()
                )
            },

            filter_selected_by_alert_model(){
                const { devices = [], sensors = []} = this.model
                this.isdevicealert
                    ? devices.length !== 0
                        ?   this.items.map(({id}, i) => devices.includes(id) 
                                ? this.$refs.selectableTable.selectRow(i) : null
                            )
                        :   this.selectAllRows()

                    : sensors.length !== 0
                        ?   this.items.filter(({podid}, i) => sensors.includes(podid) 
                                ? this.$refs.selectableTable.selectRow(i) : null
                            )
                        :   this.selectAllRows()                
            },

            draw_devices(){
                this.items = this.devices.filter(({sensor_types}) => sensor_types.filter(i =>
                    this.applicable_sensor_types.includes(i)
                ).length > 0)

                this.fields = this.device_fields
                this.table_name = 'Devices'
            },

            draw_sensors(){
                this.items = this.sensors.filter(({sensor_type}) => this.applicable_sensor_types.includes(sensor_type))
                this.fields = this.sensor_fields
                this.table_name = 'Sensors'
            },

            async retrieve_device_and_sensors(){
                const generator = get_devices_and_sensors(this.userData.accountId)
                const { value: { alert, data = [] }} = await generator.next()

                this.devices = data.map(({ id, name, device_type_desc, imei, sensors }) => ({
                    id:id, name:name, device_type_name:device_type_desc, imei:imei,
                    sensor_types: sensors.map(({sensor_type_id}) => sensor_type_id)
                }))

                this.sensors = data.map(({ name, imei, sensors }) => 
                    sensors.map(({ sensor_type_desc, podid, sensor_type_id }) => ({
                        device: name || imei, sensor_type_name: sensor_type_desc, 
                        podid: podid, sensor_type: sensor_type_id                   
                    }))
                ).flat()
            },

            format_device_array(){
                return this.table_name === 'Devices' && this.selected.length < this.items.length 
                    ? this.selected.map(({id}) => id) 
                    : []
            },

            format_sensor_array(){
                return this.table_name === 'Sensors' && this.selected.length < this.items.length
                    ? this.selected.map(({podid}) => podid) 
                    : []
            },

            capitalize(value){
                return value ? String(value).charAt(0).toUpperCase() + String(value).slice(1).toLowerCase() : ''
            },

            format_time_window(){
              var val = this.timeWindowDays
              val += ':'
              val += this.timeWindowStartHour + "|" + this.timeWindowStartHourAMorPM
              val += '-'
              val += this.timeWindowEndHour + "|" + this.timeWindowEndHourAMorPM

              //console.log("format_time_window=" + val);
              return val;
            },

          populate_time_window_form(){

            //console.log("time_window=" + this.model.timeWindow);
            
            if (this.model.timeWindow) {
              var days = this.model.timeWindow.split(":")[0]
              this.timeWindowDays = days.split(',')

              var hours = this.model.timeWindow.split(":")[1]
              var startHour = hours.split("-")[0]
              var endHour = hours.split("-")[1]

              this.timeWindowStartHour = startHour.split("|")[0]
              this.timeWindowStartHourAMorPM = startHour.split("|")[1]
              this.timeWindowEndHour = endHour.split("|")[0]
              this.timeWindowEndHourAMorPM = endHour.split("|")[1]
            }
          },

        }
    }
</script>

<style scoped>
    .btn-secondary {
        color: #fff !important;
        background-color: black;
    }

</style>
